module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-1-f7769a228b98c10c04c73b37ce8cec5c.jpg";